import moment from "moment";

export const getItemSize = (itemsPerRow: number, gridSize: number) => {
  return Math.round(gridSize / itemsPerRow);
};

export const getMaskedValue = (value: any, min: number, max: number) => {
  if (value > max) {
    return max;
  }

  if (value < min) {
    return min;
  }

  return Number(value);
};
export const setNumToFixNotRound = (num?: string) => {
  if (!num) {
    return 0;
  }

  const number = num.toString() || "0.00";

  if (Boolean(number?.match(/^-?\d+(?:\.\d{0,2})?/))) {
    const round = number.match(/^-?\d+(?:\.\d{0,2})?/);
    if (round) {
      return parseFloat(round[0]);
    }
    return 0;
  } else return 0;
};
export const numberFormatting = (num: number) => {
  let res = "";
  if (num) {
    res = num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  } else {
    return 0;
  }
  return res;
};

export function hexToRgbA(hex: string) {
  let c: any;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split("");
    if (c.length == 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = `0x${c.join("")}`;
    return `rgba(${[(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",")},1)`;
  }
  throw new Error("Bad Hex");
}
export function convertUTCDateToLocalDate(date: any) {
  const newDate = new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
  return newDate;
}
export function convertUTCDateWithTimezone(date: any) {
  const newDate = new Date(date.getTime());
  return newDate;
}
export function filterBy(data: any) {
  let startDate = "";
  let endDate = "";
  let isCustomDate = false;

  const td = new Date();
  const now = moment().format("YYYY-MM-DDTHH:mm");
  const todayStart = moment(new Date(new Date().setDate(td.getDate())).setHours(0, 0)).format(
    "YYYY-MM-DDTHH:mm"
  );
  //.setHours(23, 59))
  const todayEnd = moment(new Date(new Date().setDate(td.getDate())).setHours(23, 59)).format(
    "YYYY-MM-DDTHH:mm"
  );
  const yesterdayStart = moment(
    new Date(new Date().setDate(td.getDate() - 1)).setHours(0, 0)
  ).format("YYYY-MM-DDTHH:mm");
  const yesterdayEnd = moment(
    new Date(new Date().setDate(td.getDate() - 1)).setHours(23, 59)
  ).format("YYYY-MM-DDTHH:mm");
  const lastWeek = moment(new Date(new Date().setDate(td.getDate() - 6)).setHours(0, 0)).format(
    "YYYY-MM-DDTHH:mm"
  );
  const lastMonth = moment(new Date(new Date().setDate(td.getDate() - 29)).setHours(0, 0)).format(
    "YYYY-MM-DDTHH:mm"
  );

  if (data.value === "today") {
    startDate = todayStart;
    endDate = todayEnd;
  }
  if (data.value === "yesterday") {
    startDate = yesterdayStart;
    endDate = yesterdayEnd;
  }

  if (data.value === "lastWeek") {
    startDate = lastWeek;
    endDate = todayEnd;
  }
  if (data.value === "lastMonth") {
    startDate = lastMonth;
    endDate = todayEnd;
  }
  if (
    data.value === "today" ||
    data.value === "yesterday" ||
    data.value === "lastWeek" ||
    data.value === "lastMonth"
  ) {
    isCustomDate = false;
  }
  if (data.value === "custom") {
    isCustomDate = true;
    startDate = todayStart;
    endDate = now;
  }
  return { startDate, endDate, isCustomDate };
}
